module.exports = __webpack_public_path__ + "static/media/purple2.6281c5ac.png";